import Icon from '../AppIcon';

const MobileMenuButton = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="mobile-menu-button"
      aria-label={isOpen ? 'Chiudi menu' : 'Apri menu'}
      aria-expanded={isOpen}
    >
      <Icon 
        name={isOpen ? 'X' : 'Menu'} 
        size={24} 
        color="currentColor"
      />
    </button>
  );
};

export default MobileMenuButton;